<section class="hero-section relative">
  <div class="hero-inner relative z-10 grid grid-cols-1 md:grid-cols-2 items-center gap-8 md:gap-0 py-16 md:py-24 rounded-2xl">
    <!-- Left column -->
    <div class="flex flex-col gap-5 md:gap-6" data-aos="fade-up">
      <!-- Badge -->
      <div>
        <span class="inline-flex items-center gap-2 rounded-full border border-[rgba(76,234,99,0.25)] bg-[rgba(42,237,115,0.15)] py-[5px] px-[14px] text-[11px] leading-[18px] font-bold text-[#4CEA63]">
          <span class="relative flex h-[5px] w-[5px]">
            <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#4CEA63] opacity-75"></span>
            <span class="relative inline-flex rounded-full h-[5px] w-[5px] bg-[#4CEA63]"></span>
          </span>
          <app-icon name="svg:sa-flag" [size]="14" />
          {{ 'talentSearchV2.hero.badge' | translate }}
        </span>
      </div>

      <!-- Main heading -->
      <h1 class="text-[32px] md:text-[44px] lg:text-[58px] leading-[1.07] lg:leading-[62px] font-[900] tracking-[-2px] text-white"
          [innerHTML]="'talentSearchV2.hero.title' | translate | accent">
      </h1>

      <!-- Subtitle -->
      <p class="max-w-[460px] text-[17px] leading-[30px] font-normal text-[#FFFFFF99]">
        {{ 'talentSearchV2.hero.subtitle' | translate }}
      </p>

      <!-- Stats row -->
      <div class="w-fit md:w-full grid grid-cols-[auto_auto_auto_auto] md:flex flex-nowrap justify-start gap-8 md:gap-0" data-aos="fade-up" data-aos-delay="100">
        <ng-container *ngFor="let stat of stats; let last = last">
          <div class="flex flex-col md:border-e md:border-[#ffffff1a] md:px-5 md:first:ps-0 md:last:pe-0"
               [class.md:!border-e-0]="last"
          >
            <span class="text-[16px] md:text-[28px] leading-[22px] md:leading-[28px] font-[900] text-white tracking-[-1px] whitespace-nowrap"
              [innerHTML]="stat.statKey | translate | accent">
            </span>
            <span class="text-[9px] md:text-[11px] leading-[13px] md:leading-[18px] font-medium text-[#FFFFFF66] mt-0.5"
              [innerHTML]="stat.labelKey | translate">
            </span>
          </div>
        </ng-container>
      </div>

      <!-- CTA buttons -->
      <div class="flex flex-col gap-3 sm:flex-row sm:items-center" data-aos="fade-up" data-aos-delay="200">
        <a routerLink="/talent-search" fragment="pricing"
           class="inline-flex items-center justify-center gap-2 rounded-full bg-[#4CEA63] px-7 py-3.5 text-[16px] leading-[25.6px] font-bold text-[#061430] shadow-[0_4px_16px_0_#4CEA634D] transition-all duration-200 hover:brightness-105">
          {{ 'talentSearchV2.hero.ctaPrimary' | translate }}

          <span class="rtl:flip inline-grid place-items-center">
            <app-icon name="tabler:arrow-narrow-right" />
          </span>
        </a>
        <button type="button" (click)="openBookDemo()"
           class="inline-flex items-center justify-center gap-2 rounded-full border border-white/20 px-7 py-3.5 text-[16px] leading-[25.6px] font-medium text-white/90 transition-all duration-200 hover:border-white/35 hover:bg-white/10">
          {{ 'talentSearchV2.hero.ctaSecondary' | translate }}
          <app-icon name="tabler:calendar-event" />
        </button>
      </div>

      <!-- Trust row -->
      <div class="flex flex-wrap items-center gap-3" data-aos="fade-up" data-aos-delay="300">
        <div class="flex -space-x-2 rtl:space-x-reverse">
          <span class="inline-flex h-7 w-7 items-center justify-center rounded-full border-2 border-[#061430] bg-[#353CD8] text-[9px] font-extrabold text-white">{{'talentSearchV2.hero.chars.s' | translate| uppercase}}</span>
          <span class="inline-flex h-7 w-7 items-center justify-center rounded-full border-2 border-[#061430] bg-[#353CD8] text-[9px] font-extrabold text-white">{{'talentSearchV2.hero.chars.n' | translate| uppercase}}</span>
          <span class="inline-flex h-7 w-7 items-center justify-center rounded-full border-2 border-[#061430] bg-[#353CD8] text-[9px] font-extrabold text-white">{{'talentSearchV2.hero.chars.a' | translate| uppercase}}</span>
          <span class="inline-flex h-7 w-7 items-center justify-center rounded-full border-2 border-[#061430] bg-[#353CD8] text-[9px] font-extrabold text-white">{{'talentSearchV2.hero.chars.r' | translate| uppercase}}</span>
        </div>
        <span class="text-[#4CEA63] text-[12px] tracking-[1px]">★★★★★</span>
        <span class="text-[12px] text-[#FFFFFF66]">{{ 'talentSearchV2.hero.trustText' | translate }}</span>
      </div>
    </div>

    <!-- Right column -->
    <app-responsive-img
      name="hero"
      pictureClass="w-full lg:w-[120%] max-w-none lg:justify-self-start"
      [alt]="'talentSearchV2.hero.imageAlt' | translate"
      loading="eager"
      imgClass="w-full max-w-none"
      sizes="(min-width: 768px) 60vw, 100vw"
    />
  </div>
</section>
